
/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  ResumePreviewResource,
  SimpleError,
  UpdateExperiencesRequest,
} from '../models';
import {
    ResumePreviewResourceFromJSON,
    ResumePreviewResourceToJSON,
    SimpleErrorFromJSON,
    SimpleErrorToJSON,
    UpdateExperiencesRequestFromJSON,
    UpdateExperiencesRequestToJSON,
} from '../models';

export interface GetPreviewFromResumeRequest {
    resume: Blob;
}

export interface UpdateBatchExperiencesRequest {
    updateExperiencesRequest: UpdateExperiencesRequest;
}

/**
 * 
 */
export class ResumeApi extends runtime.BaseAPI {

    /**
     * Returns a preview from resume extraction
          */
    async getPreviewFromResumeRaw(requestParameters: GetPreviewFromResumeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<ResumePreviewResource>> {
        if (requestParameters['resume'] == null) {
            throw new runtime.RequiredError(
                'resume',
                'Required parameter "resume" was null or undefined when calling getPreviewFromResume().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['resume'] != null) {
            formParams.append('resume', requestParameters['resume'] as any);
        }

        const response = await this.request<ResumePreviewResource>({
            path: `/profile/api/from-resume/preview`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        if (response._data) { response._data=ResumePreviewResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Returns a preview from resume extraction
          */
    async getPreviewFromResume(requestParameters: GetPreviewFromResumeRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<ResumePreviewResource> {
        const response = await this.getPreviewFromResumeRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update experiences
          */
    async updateBatchExperiencesRaw(requestParameters: UpdateBatchExperiencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['updateExperiencesRequest'] == null) {
            throw new runtime.RequiredError(
                'updateExperiencesRequest',
                'Required parameter "updateExperiencesRequest" was null or undefined when calling updateBatchExperiences().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/profile/api/from-resume/experiences`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateExperiencesRequestToJSON(requestParameters['updateExperiencesRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update experiences
          */
    async updateBatchExperiences(requestParameters: UpdateBatchExperiencesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateBatchExperiencesRaw(requestParameters, initOverrides);
    }

}
